<template>
  <div>
    <div v-if="reportUrl">
      <iframe :src="reportUrl" width="100%" style="height:60rem;" frameborder="0">
      </iframe>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      url: "",
    };
  },
  created() {
    this.getReport({ id: this.$route.params.id });
  },
  computed: {
    ...mapGetters({
      languages: "getLanguages",
      currentRestaurant: "getCurrentRestaurant",
      language: "getCurrentLanguage",
      reportUrl: "getReport",
    }),
  },
  methods: {
    ...mapActions({
      getReport: "getReport",
    }),
    ...mapMutations({
      loading: "loading",
    }),
  },
};
</script>

<style></style>
